import {otsBaseApi} from "../../ots-api";
import {InvoiceAccount} from "../../../model/invoice-account";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["InvoiceAccounts"]});

const invoiceAccountApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInvoiceAccount: builder.query<InvoiceAccount, {
      id: string,
      database: string | undefined
    }>({
      query: ({id, database}) => ({
        url: `/invoice/${id}`,
        method: "GET",
        params: removeUndefined({
          database: database
        })
      }),
      providesTags: (result, error, arg) => [{type: "InvoiceAccounts", id: arg.id}]
    }),
  })
});

export const {
  useGetInvoiceAccountQuery,
} = invoiceAccountApi;
